import { Component, OnInit } from '@angular/core';
import { SeoMetadataService } from '@shared/services/seo-metadata.service';

@Component({
  selector: 'astrea-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor(
    private seo: SeoMetadataService,
  ) { }

  ngOnInit(): void {
    this.setMetadata();
  }

  setMetadata(): void {
    this.seo.setMetadata({
      title: 'Página no encontrada 404',
      description: 'Lá página solicitada no existe.',
      relativeUrl: '/404',
      shouldIndex: false,
    });
  }

}
